@if (service.vm$ | async; as vm) {
  <celum-systembar [systembar]="vm.systemBar">
    @if (vm.systemBar?.notificationFeatureEnabled && vm.hasRequiredLicensesForSBEN) {
      <systembar-notifications class="celum-systembar_components" notifications></systembar-notifications>
    }
    <!-- Deprecated, should be removed with https://celum.atlassian.net/browse/CH-9973 -->
    @if (vm.systemBar?.formatsFeatureEnabled && vm.activeFormatsAccountAccesses.length > 0) {
      <celum-systembar-formats class="celum-systembar_components" formats [contextMenuItems]="vm.formats.contextMenuItems"></celum-systembar-formats>
    }
    <celum-user-avatar small-avatar [showTooltip]="false" [size]="AVATAR_SIZE.m" [user]="vm.user"></celum-user-avatar>
    <celum-user-avatar big-avatar [showTooltip]="false" [size]="60" [user]="vm.user"></celum-user-avatar>
  </celum-systembar>
}
